'use strict';

function getRules() {
    return {
        apptype: [{ required: true, message: "请填写应用类型", trigger: ['blur', 'change'] }],

        name: [{ required: true, message: "请填写应用名称", trigger: ['blur', 'change'] }],

        rank: [{ required: true, message: "请选择级别", trigger: ['blur', 'change'] }],

        superviser: [{ required: true, message: "请填写负责人员", trigger: ['blur', 'change'] }],

        git_path: [{ required: true, message: '请填写Git 地址', trigger: ['blur', 'change'] }],

        devuser: [{ required: true, message: '请填写开发人员', trigger: ['blur', 'change'] }],

        projectusers: [{ required: true, message: '请填写项目经理', trigger: ['blur', 'change'] }],

        pmuser: [{ required: true, message: '请填写产品经理', trigger: ['blur', 'change'] }],

        maintainusers: [{ required: true, message: '请填写运维人员', trigger: ['blur', 'change'] }],

        qauser: [{ required: true, message: '请填写测试人员', trigger: ['blur', 'change'] }],

        mails: [{ required: true, message: '请填写邮件组', trigger: ['blur', 'change'] }],

        server: [{ required: true, message: '请填写服务器', trigger: ['blur', 'change'] }],

        value: [{ required: true, message: '请输入参数值', trigger: ['blur', 'change'] }],


        title: [
            { required: true, message: '请填写标题', trigger: ['blur', 'change'] }
        ],
        app: [
            { required: true, message: '请输入应用关键字', trigger: ['blur', 'change'] }
        ],
        env: [
            { required: true, message: '请选择发布环境', trigger: ['blur', 'change'] }
        ],
        method_value: [
            { required: true, message: '请输入tag', trigger: ['blur', 'change'] }
        ],
        target_value: [
            { required: true, message: '请选择组名', trigger: ['blur', 'change'] }
        ],
        target_list: [
            { required: true, message: '请选择发布列表', trigger: ['blur', 'change'] }
        ],
    }
}

function buildParams() {
    return {
        title: [
            { required: true, message: '请填写标题', trigger: ['blur', 'change'] },
            { min: 5, message: '必须大于5个字符', trigger: ['blur', 'change'] }
        ],
        app: [
            { required: true, message: '请输入应用关键字', trigger: ['blur', 'change'] }
        ],
        env: [
            { required: true, message: '请选择发布环境', trigger: ['blur', 'change'] }
        ],
        method_value: [
            { required: true, message: '请输入tag', trigger: ['blur', 'change'] }
        ],
        target_value: [
            { required: true, message: '请选择组名', trigger: ['blur', 'change'] }
        ],
        target_list: [
            { required: true, message: '请选择发布列表', trigger: ['blur', 'change'] }
        ]
    }
}

export {
    getRules,
    buildParams
}